import { createApp, watch, nextTick } from "vue";
import { store, mutations } from "@js/vue/store";
import { registerComponents } from "@js/vue/components";
import { registerDirectives } from "@js/vue/directives";

export function initializeApp() {
	/*
	 * Create the app
	 */
	const app = createApp({
		delimiters: ["${", "}"],
		setup() {
			return { store, mutations };
		},
	});

	app.config.errorHandler = (err, instance, info) => {
		console.error("Error:", err);
		console.log("Vue component:", instance);
		console.log("Additional info:", info);
	};

	// Watch for nav height changes and update CSS custom property
	watch(() => store.navBarHeight, async (newHeight) => {
		await nextTick();
		document.documentElement.style.setProperty('--nav-bar-height', `${newHeight}px`);
	},
	{ immediate: true });
	watch(() => store.subnavBarHeight, async (newWidth) => {
		await nextTick();
		document.documentElement.style.setProperty('--subnav-bar-height', `${newWidth}px`);
	},
	{ immediate: true });

	// Register all components
	registerComponents(app);

	// Register all directives
	registerDirectives(app);

	/*
	 * Mount the app
	 */
	app.mount("#app");
}
